var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _g262, _g263, _g264, _g265, _g266, _g267, _g268, _g269, _g270, _g271, _g272, _g273, _g274, _g275, _g276, _g277, _g278, _g279, _g280, _g281, _g282, _g283, _g284, _g285, _g286, _g287, _g288, _g289, _g290, _g291, _g292, _g293, _g294, _g295, _g296, _g297, _g298, _g299, _g300, _g301, _g302, _g303, _g304, _g305, _g306, _g307, _g308, _g309, _g310, _g311, _g312, _g313, _g314, _g315, _g316, _g317, _g318, _g319, _g320, _g321, _g322, _g323, _g324, _g325, _g326, _g327, _g328, _g329, _g330, _g331, _g332, _g333, _g334, _g335, _g336, _g337, _g338, _g339, _g340, _g341, _g342, _g343, _g344, _g345, _g346, _g347, _g348, _g349, _g350, _g351, _g352, _g353, _g354, _g355, _g356, _g357, _g358, _g359, _g360, _g361, _g362, _g363, _g364, _g365, _g366, _g367, _g368, _g369, _g370, _g371, _g372, _g373, _g374, _g375, _g376, _g377, _g378, _g379, _g380, _g381, _g382, _g383, _g384, _g385, _g386, _g387, _g388, _g389, _g390, _g391, _g392, _g393, _g394, _g395, _g396, _g397, _g398, _g399, _g400, _g401, _g402, _g403, _g404, _g405, _g406, _g407, _g408, _g409, _g410, _g411, _g412, _g413, _g414, _g415, _g416, _g417, _g418, _g419, _g420, _g421, _g422, _g423, _g424, _g425, _g426, _g427, _g428, _g429, _g430, _g431, _g432, _g433, _g434, _g435, _g436, _g437, _g438, _g439, _g440, _g441, _g442, _g443, _g444, _g445, _g446, _g447, _g448, _g449, _g450, _g451, _g452, _g453, _g454, _g455, _g456, _g457, _g458, _g459, _g460, _g461, _g462, _g463, _g464, _g465, _g466, _g467, _g468, _g469, _g470, _g471, _g472, _g473, _g474, _g475, _g476, _g477, _g478, _g479, _g480, _g481, _g482, _g483, _g484, _g485, _g486, _g487, _g488, _g489, _g490, _g491, _g492, _g493, _g494, _g495, _g496, _g497, _g498, _g499, _g500, _g501, _g502, _g503, _g504, _g505, _g506, _g507, _g508, _g509, _g510, _g511, _g512, _g513, _g514;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarmosharkM9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 193.22 386.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5F6368;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.71px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mouseBodyFill",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 210,
    x2: 193.22,
    y2: 210
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A5A5A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mouseLeftButtonFill",
    gradientUnits: "userSpaceOnUse",
    x1: 20,
    y1: 15,
    x2: 96,
    y2: 169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CACACA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mouseRightButtonFill",
    gradientUnits: "userSpaceOnUse",
    x1: 98,
    y1: 20,
    x2: 186,
    y2: 155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mouseCenterFill",
    gradientUnits: "userSpaceOnUse",
    x1: 83,
    y1: 0,
    x2: 110,
    y2: 108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mouseWheelFill",
    gradientUnits: "userSpaceOnUse",
    x1: 84,
    y1: 53,
    x2: 109,
    y2: 107
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "MOUSE_BODY_COLOR",
    fill: "url(#mouseBodyFill)",
    d: "M83.11 .73 C50 2 24 16 10 42 C4 53 3 65 3.5 77 L7 128 C8 163 6 200 4 236 C1 254 0 272 .35 288 C1 330 21 364 57 380 C82 391 111 389 136 378 C170 363 191 330 192.87 289 C193 272 192 254 189.2 236 C187.2 200 185.2 163 186.2 128 L189.7 77 C190.2 65 189.2 53 183.2 42 C169.2 16 143.2 2 110.11 .73 C101 -1 92 -1 83.11 .73 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "MOUSE_LEFT_COLOR",
    fill: "url(#mouseLeftButtonFill)",
    d: "M84.14 3.21 C61 6 35 17 18.72 29.6 C13 33 9 37 7.96 40.22 C7.95 53.8 8.5 67.4 9.59 80.9 C10.2 94.6 11.1 108.3 12.22 121.94 C13.05 134.1 14.1 146.3 15.35 158.32 C15.9 164.8 20.1 169.2 26.05 169.78 H95.9 V107.48 C89.3 107.1 84.14 104.2 84.14 99.9 Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "MOUSE_RIGHT_COLOR",
    fill: "url(#mouseRightButtonFill)",
    d: "M109.08 3.21 C132.22 6 158.22 17 174.5 29.6 C180.22 33 184.22 37 185.26 40.22 C185.27 53.8 184.72 67.4 183.63 80.9 C183.02 94.6 182.12 108.3 181 121.94 C180.17 134.1 179.12 146.3 177.87 158.32 C177.32 164.8 173.12 169.2 167.17 169.78 H97.32 V107.48 C103.92 107.1 109.08 104.2 109.08 99.9 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "MOUSE_CENTER_COLOR",
    fill: "url(#mouseCenterFill)",
    d: "M83.11 .73 C91 -.5 102 -.5 110.11 .73 L110.08 99.9 C107 104 103 106.7 97.32 107.5 H95.9 C90 106.7 86 104 83.14 99.9 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "MOUSE_CENTER_SEAM_COLOR",
    fill: "#1A1A1A",
    d: "M95.9 106.5 H97.32 V169.3 H95.9 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "MOUSE_WHEEL_COLOR",
    fill: "url(#mouseWheelFill)",
    d: "M84.14 53 C90 50.5 103 50.5 109.08 53 V99.9 C106 104.5 102 106.7 96.61 106.7 C91 106.7 87 104.5 84.14 99.9 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "MOUSE_SIDE4_COLOR",
    fill: "#272727",
    d: "M6.4 121.2 C10.5 121.5 13.5 125 14 130 L17.2 162 C17.5 168 13.5 176 8.9 180 L5.7 172.9 Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "MOUSE_SIDE5_COLOR",
    fill: "#242424",
    d: "M9 180 C13 180 16 185 16.5 191 L17.3 231.9 C16.8 234.5 14 236 11 236 L7.7 230.4 Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.02,
    y1: 339.97,
    x2: 14.11,
    y2: 340.12
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-2",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.23,
    y1: 339.86,
    x2: 14.31,
    y2: 340.01
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-3",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.48,
    y1: 288.16,
    x2: 0.45,
    y2: 287.61
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-4",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.75,
    y1: 230.41,
    x2: 8.14,
    y2: 231.28
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "7.75 230.41 7.39 229.32 7 228.14 6.71 227.26"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-5",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.1,
    y1: 228.06,
    x2: 8.14,
    y2: 231.28
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-6",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.13,
    y1: 128.16,
    x2: 7.13,
    y2: 128.13
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-2",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.28 121.42 5.87 114.46 5.02 99.44 4.54 89.97"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-3",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.34 129.39 4.02 141.06 4.92 157.39 5.63 172.68"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-7",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.54,
    y1: 89.97,
    x2: 4.53,
    y2: 89.84
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-4",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.5 60.78 3.86 73.58 4.53 89.83"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-5",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.97 183.43 6.05 187.05 6.11 191.02 6.11 191.46"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-8",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.85,
    y1: 179.89,
    x2: 8.79,
    y2: 176.23
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-9",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.35,
    y1: 280.61,
    x2: 0.45,
    y2: 287.61
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-10",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.01,
    y1: 235.99,
    x2: 15.97,
    y2: 235.99
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-11",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.1,
    y1: 235.52,
    x2: 16.46,
    y2: 235.52
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-12",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.33,
    y1: 175.37,
    x2: 7.17,
    y2: 175.17
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-13",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.17,
    y1: 175.17,
    x2: 6.61,
    y2: 174.36
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-6",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.67 172.91 6.17 173.7 6.61 174.36"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-14",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.67,
    y1: 172.9,
    x2: 5.67,
    y2: 172.92
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-15",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.63,
    y1: 172.68,
    x2: 5.67,
    y2: 172.9
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-16",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.45,
    y1: 125.25,
    x2: 13.47,
    y2: 125.52
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-17",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.41,
    y1: 124.32,
    x2: 12.5,
    y2: 125.48
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-18",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.28,
    y1: 122.67,
    x2: 12.41,
    y2: 124.32
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-19",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.22,
    y1: 121.94,
    x2: 12.28,
    y2: 122.67
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-20",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.23,
    y1: 121.94,
    x2: 12.48,
    y2: 125.21
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-7",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "6.19 222.43 5.27 230.34 4.1 239.94 3.04 248.63 2.09 256.72 1.26 264.69 0.64 272.7 0.35 280.61"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-21",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.97,
    y1: 183.43,
    x2: 6.12,
    y2: 182.93
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-22",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8.88,
    y1: 176.23,
    x2: 8.88,
    y2: 176.21
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-23",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.93,
    y1: 55.14,
    x2: 85.84,
    y2: 56.52
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-24",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.14,
    y1: 54.96,
    x2: 87.39,
    y2: 51.71
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-25",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.84,
    y1: 61.95,
    x2: 84.14,
    y2: 63.65
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-26",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.25,
    y1: 231.98,
    x2: 13.99,
    y2: 231.98
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-27",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.4,
    y1: 121.24,
    x2: 6.35,
    y2: 121.12
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-28",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.12,
    y1: 182.93,
    x2: 7.34,
    y2: 180.96
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-29",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.67,
    y1: 81.21,
    x2: 90.22,
    y2: 76.96
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-30",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.97,
    y1: 106.84,
    x2: 88.78,
    y2: 107.04
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-31",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 109.08,
    y1: 100.19,
    x2: 110.08,
    y2: 99.9
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-32",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.59,
    y1: 80.85,
    x2: 11.57,
    y2: 80.82
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-33",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.57,
    y1: 80.83,
    x2: 11.55,
    y2: 80.79
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-34",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.22,
    y1: 87.73,
    x2: 88.67,
    y2: 91.99
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-35",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 81.21,
    x2: 92.23,
    y2: 85.47
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-36",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 86.6,
    x2: 95.48,
    y2: 81.92
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-37",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.23,
    y1: 96.24,
    x2: 93.78,
    y2: 91.99
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-38",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.44,
    y1: 81.21,
    x2: 100.99,
    y2: 76.96
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-39",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.74,
    y1: 91.28,
    x2: 99.44,
    y2: 86.6
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-40",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.99,
    y1: 87.73,
    x2: 99.44,
    y2: 91.99
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-41",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.55,
    y1: 81.21,
    x2: 103,
    y2: 85.47
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-42",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.8,
    y1: 180.11,
    x2: 11.98,
    y2: 180.11
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-43",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.87,
    y1: 179.41,
    x2: 9.99,
    y2: 179.41
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-44",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.36,
    y1: 178.58,
    x2: 11.28,
    y2: 178.58
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-45",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.12,
    y1: 175.38,
    x2: 7.34,
    y2: 175.38
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-46",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.33,
    y1: 175.37,
    x2: 9.13,
    y2: 175.37
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-47",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.13,
    y1: 172.76,
    x2: 9.31,
    y2: 172.76
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-48",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.17,
    y1: 171.74,
    x2: 8.97,
    y2: 171.74
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-49",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 168.09,
    y1: 169.29,
    x2: 25.13,
    y2: 169.29
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-50",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 168.09,
    y1: 167.88,
    x2: 98.74,
    y2: 167.88
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-51",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 25.13,
    y1: 167.88,
    x2: 94.48,
    y2: 167.88
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-52",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.62,
    y1: 54.77,
    x2: 88.57,
    y2: 53.92
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-53",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.13,
    y1: 72.89,
    x2: 83.13,
    y2: 72.99
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-54",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.11,
    y1: 55.23,
    x2: 83.11,
    y2: 55.78
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-55",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.14,
    y1: 81.5,
    x2: 83.14,
    y2: 82.88
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-56",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.14,
    y1: 90.85,
    x2: 83.14,
    y2: 91.7
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-57",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.14,
    y1: 3.21,
    x2: 84.14,
    y2: 100.19
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-58",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.84,
    y1: 105.21,
    x2: 85.84,
    y2: 56.52
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-59",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.93,
    y1: 106.11,
    x2: 86.93,
    y2: 55.14
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-60",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.02,
    y1: 106.62,
    x2: 88.02,
    y2: 55.14
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-61",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.03,
    y1: 55.36,
    x2: 88.03,
    y2: 106.62
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-62",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.03,
    y1: 106.62,
    x2: 88.03,
    y2: 55.39
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-63",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.49,
    y1: 106.73,
    x2: 88.49,
    y2: 54.8
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-64",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.67,
    y1: 102.39,
    x2: 88.67,
    y2: 102.69
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-65",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.67,
    y1: 70.81,
    x2: 88.67,
    y2: 70.51
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-66",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.67,
    y1: 62.31,
    x2: 88.67,
    y2: 61.74
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-67",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.67,
    y1: 56.73,
    x2: 88.67,
    y2: 55.97
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-68",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.22,
    y1: 98.64,
    x2: 90.22,
    y2: 98.93
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-69",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.22,
    y1: 74.56,
    x2: 90.22,
    y2: 74.27
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-70",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.22,
    y1: 65.11,
    x2: 90.22,
    y2: 64.55
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-71",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.22,
    y1: 58.25,
    x2: 90.22,
    y2: 57.5
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-72",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.22,
    y1: 54.48,
    x2: 90.22,
    y2: 53.96
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-73",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.23,
    y1: 98.73,
    x2: 92.23,
    y2: 99.02
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-74",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.23,
    y1: 74.47,
    x2: 92.23,
    y2: 74.18
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-75",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.23,
    y1: 64.94,
    x2: 92.23,
    y2: 64.39
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-76",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.23,
    y1: 58.02,
    x2: 92.23,
    y2: 57.28
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-77",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.23,
    y1: 54.25,
    x2: 92.23,
    y2: 53.7
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-78",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 97.72,
    x2: 93.78,
    y2: 98.01
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-79",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 102.62,
    x2: 93.78,
    y2: 102.92
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-80",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 75.48,
    x2: 93.78,
    y2: 75.19
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-81",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 70.58,
    x2: 93.78,
    y2: 70.28
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-82",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 65.71,
    x2: 93.78,
    y2: 65.16
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-83",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 61.87,
    x2: 93.78,
    y2: 61.32
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-84",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 58.45,
    x2: 93.78,
    y2: 57.71
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-85",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 56.15,
    x2: 93.78,
    y2: 55.4
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-86",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 54.59,
    x2: 93.78,
    y2: 53.75
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-87",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.76,
    y1: 93.66,
    x2: 95.76,
    y2: 93.95
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-88",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.76,
    y1: 104.11,
    x2: 95.76,
    y2: 104.66
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-89",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.76,
    y1: 79.54,
    x2: 95.76,
    y2: 79.25
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-90",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.76,
    y1: 69.09,
    x2: 95.76,
    y2: 68.54
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-91",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.76,
    y1: 60.74,
    x2: 95.76,
    y2: 60
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-92",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.76,
    y1: 55.52,
    x2: 95.76,
    y2: 54.67
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-93",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.9,
    y1: 166.46,
    x2: 95.9,
    y2: 107.48
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-94",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.32,
    y1: 166.46,
    x2: 97.32,
    y2: 107.48
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-95",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 98.03,
    y1: 93.65,
    x2: 98.03,
    y2: 93.94
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-96",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 98.03,
    y1: 104.1,
    x2: 98.03,
    y2: 104.65
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-97",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 98.03,
    y1: 79.55,
    x2: 98.03,
    y2: 79.26
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-98",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 98.03,
    y1: 69.1,
    x2: 98.03,
    y2: 68.55
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-99",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 98.03,
    y1: 60.76,
    x2: 98.03,
    y2: 60.01
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-100",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 98.03,
    y1: 55.53,
    x2: 98.03,
    y2: 54.69
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-101",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.89,
    y1: 53.7,
    x2: 93.92,
    y2: 53.24
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-102",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.6,
    y1: 54.77,
    x2: 104.65,
    y2: 53.92
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-103",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103,
    y1: 96.24,
    x2: 104.55,
    y2: 91.99
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-104",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.36,
    y1: 178.56,
    x2: 11.28,
    y2: 178.58
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-105",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.94,
    y1: 179.42,
    x2: 9.99,
    y2: 179.41
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-106",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.66,
    y1: 161.62,
    x2: 15.67,
    y2: 161.64
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-107",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.32,
    y1: 163.92,
    x2: 95.9,
    y2: 163.92
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-108",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.32,
    y1: 163.89,
    x2: 95.9,
    y2: 163.89
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-109",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.9,
    y1: 162.19,
    x2: 97.32,
    y2: 162.19
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-110",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.9,
    y1: 162.16,
    x2: 97.32,
    y2: 162.16
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-111",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.9,
    y1: 161.03,
    x2: 97.32,
    y2: 161.03
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-112",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.32,
    y1: 160.89,
    x2: 95.9,
    y2: 160.89
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-113",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.32,
    y1: 160.64,
    x2: 95.9,
    y2: 160.64
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-114",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.9,
    y1: 159.58,
    x2: 97.32,
    y2: 159.58
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-115",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.9,
    y1: 158.54,
    x2: 97.32,
    y2: 158.54
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-116",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.9,
    y1: 153.98,
    x2: 97.32,
    y2: 153.98
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-117",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 176.56,
    y1: 161.62,
    x2: 177.55,
    y2: 161.64
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-118",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.33,
    y1: 53.7,
    x2: 99.3,
    y2: 53.24
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-119",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.44,
    y1: 97.72,
    x2: 99.44,
    y2: 98.01
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-120",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.44,
    y1: 102.62,
    x2: 99.44,
    y2: 102.92
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-121",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.44,
    y1: 75.48,
    x2: 99.44,
    y2: 75.19
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-122",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.44,
    y1: 70.58,
    x2: 99.44,
    y2: 70.28
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-123",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.44,
    y1: 65.71,
    x2: 99.44,
    y2: 65.16
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-124",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.44,
    y1: 61.87,
    x2: 99.44,
    y2: 61.32
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-125",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.44,
    y1: 58.45,
    x2: 99.44,
    y2: 57.71
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-126",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.44,
    y1: 56.15,
    x2: 99.44,
    y2: 55.4
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-127",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.44,
    y1: 54.59,
    x2: 99.44,
    y2: 53.75
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-128",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.99,
    y1: 98.73,
    x2: 100.99,
    y2: 99.02
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-129",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.99,
    y1: 74.47,
    x2: 100.99,
    y2: 74.18
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-130",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.99,
    y1: 64.94,
    x2: 100.99,
    y2: 64.39
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-131",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.99,
    y1: 58.02,
    x2: 100.99,
    y2: 57.28
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-132",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.99,
    y1: 54.25,
    x2: 100.99,
    y2: 53.7
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-133",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103,
    y1: 98.64,
    x2: 103,
    y2: 98.93
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-134",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103,
    y1: 74.56,
    x2: 103,
    y2: 74.27
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-135",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103,
    y1: 65.11,
    x2: 103,
    y2: 64.55
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-136",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103,
    y1: 58.25,
    x2: 103,
    y2: 57.5
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-137",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103,
    y1: 54.48,
    x2: 103,
    y2: 53.96
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-138",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.55,
    y1: 102.39,
    x2: 104.55,
    y2: 102.69
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-139",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.55,
    y1: 70.81,
    x2: 104.55,
    y2: 70.51
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-140",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.55,
    y1: 62.31,
    x2: 104.55,
    y2: 61.74
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-141",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.55,
    y1: 56.73,
    x2: 104.55,
    y2: 55.97
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-142",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.74,
    y1: 54.8,
    x2: 104.74,
    y2: 106.73
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-143",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 105.19,
    y1: 55.39,
    x2: 105.19,
    y2: 106.62
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-144",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 105.19,
    y1: 106.62,
    x2: 105.19,
    y2: 55.36
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-145",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 105.2,
    y1: 55.14,
    x2: 105.2,
    y2: 106.62
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-146",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 106.29,
    y1: 106.11,
    x2: 106.29,
    y2: 55.14
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-147",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.38,
    y1: 56.52,
    x2: 107.38,
    y2: 105.21
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-148",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 109.08,
    y1: 3.21,
    x2: 109.08,
    y2: 100.19
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-149",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.08,
    y1: 90.85,
    x2: 110.08,
    y2: 92.98
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-150",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.08,
    y1: 90.85,
    x2: 110.08,
    y2: 91.7
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-151",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.08,
    y1: 87.73,
    x2: 110.08,
    y2: 88.28
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-152",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.08,
    y1: 87.73,
    x2: 110.08,
    y2: 88.28
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-153",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.08,
    y1: 80.22,
    x2: 110.08,
    y2: 82.35
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-154",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.11,
    y1: 55.23,
    x2: 110.11,
    y2: 55.78
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-155",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.11,
    y1: 55.23,
    x2: 110.11,
    y2: 55.78
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-156",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.08,
    y1: 99.35,
    x2: 110.08,
    y2: 99.9
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-157",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.67,
    y1: 91.99,
    x2: 90.22,
    y2: 96.24
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-158",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.22,
    y1: 85.47,
    x2: 88.67,
    y2: 81.21
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-159",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 91.99,
    x2: 92.23,
    y2: 87.73
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-160",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 179.77,
    y1: 125.25,
    x2: 180.74,
    y2: 125.21
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-161",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 179.75,
    y1: 125.52,
    x2: 180.72,
    y2: 125.48
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-162",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.9,
    y1: 128.87,
    x2: 97.32,
    y2: 128.87
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-163",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.02,
    y1: 124.34,
    x2: 6.84,
    y2: 124.34
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-164",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 4.54,
    y1: 121.97,
    x2: 6.55,
    y2: 121.97
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-165",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.47,
    y1: 125.52,
    x2: 12.5,
    y2: 125.48
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-166",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.45,
    y1: 125.25,
    x2: 12.48,
    y2: 125.21
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-167",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.78,
    y1: 86.6,
    x2: 95.48,
    y2: 91.28
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-168",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.23,
    y1: 76.96,
    x2: 93.78,
    y2: 81.21
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-169",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.44,
    y1: 91.99,
    x2: 100.99,
    y2: 96.24
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-170",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 97.74,
    y1: 81.92,
    x2: 99.44,
    y2: 86.6
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-171",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.99,
    y1: 85.47,
    x2: 99.44,
    y2: 81.21
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-172",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.55,
    y1: 91.99,
    x2: 103,
    y2: 87.73
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-173",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103,
    y1: 76.96,
    x2: 104.55,
    y2: 81.21
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-174",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 181.63,
    y1: 80.85,
    x2: 181.66,
    y2: 80.8
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-175",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 181.65,
    y1: 80.84,
    x2: 181.68,
    y2: 80.79
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-176",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.14,
    y1: 100.19,
    x2: 83.14,
    y2: 99.9
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-177",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 104.25,
    y1: 106.84,
    x2: 104.44,
    y2: 107.04
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-178",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.22,
    y1: 96.24,
    x2: 92.23,
    y2: 96.24
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-179",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.99,
    y1: 96.24,
    x2: 103,
    y2: 96.24
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-180",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.38,
    y1: 92.98,
    x2: 109.08,
    y2: 92.98
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-181",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.84,
    y1: 91.56,
    x2: 84.14,
    y2: 91.56
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-182",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.48,
    y1: 91.28,
    x2: 97.74,
    y2: 91.28
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-183",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103,
    y1: 87.73,
    x2: 100.99,
    y2: 87.73
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-184",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.23,
    y1: 87.73,
    x2: 90.22,
    y2: 87.73
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-185",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 103,
    y1: 85.47,
    x2: 100.99,
    y2: 85.47
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-186",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 92.23,
    y1: 85.47,
    x2: 90.22,
    y2: 85.47
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-187",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 95.48,
    y1: 81.92,
    x2: 97.74,
    y2: 81.92
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-188",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.38,
    y1: 56.52,
    x2: 106.29,
    y2: 55.14
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-8",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "184.49 190.69 184.59 193.49 185.44 206.85 186.69 219.57 187.95 230.34 189.12 239.94 190.18 248.63 191.13 256.72 191.96 264.69 192.59 272.7 192.87 280.61"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-189",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 184.5,
    y1: 190.7,
    x2: 184.49,
    y2: 190.7
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-190",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 180.72,
    y1: 125.48,
    x2: 180.74,
    y2: 125.21
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-191",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 179.75,
    y1: 125.52,
    x2: 179.77,
    y2: 125.25
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-192",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 85.84,
    y1: 81.64,
    x2: 84.14,
    y2: 81.64
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-193",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.5,
    y1: 80.85,
    x2: 11.92,
    y2: 80.85
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-194",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 181.3,
    y1: 80.85,
    x2: 182.72,
    y2: 80.85
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-195",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 182.74,
    y1: 80.55,
    x2: 181.32,
    y2: 80.55
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-196",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.9,
    y1: 80.55,
    x2: 10.76,
    y2: 80.55
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-197",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 107.38,
    y1: 80.22,
    x2: 109.08,
    y2: 80.22
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-198",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.22,
    y1: 76.96,
    x2: 92.23,
    y2: 76.96
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-199",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 100.99,
    y1: 76.96,
    x2: 103,
    y2: 76.96
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-200",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 109.08,
    y1: 63.65,
    x2: 107.38,
    y2: 61.95
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-201",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 105.84,
    y1: 51.72,
    x2: 109.08,
    y2: 54.96
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-9",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "184.5 190.7 184.35 181.18 184.52 169.69 184.98 157.12 185.66 143.78 186.4 130.64"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-202",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 192.87,
    y1: 280.61,
    x2: 192.77,
    y2: 287.61
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-10",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "188.69 89.86 189.36 73.58 189.72 60.78"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-203",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 192.77,
    y1: 287.61,
    x2: 192.74,
    y2: 288.15
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    id: "LWPOLYLINE-11",
    "data-name": "LWPOLYLINE"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "186.41 130.64 187.33 114.91 188.21 99.3 188.69 89.86"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-204",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 184.49,
    y1: 190.7,
    x2: 184.5,
    y2: 190.7
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-205",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.93,
    y1: 55.14,
    x2: 88.02,
    y2: 55.14
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-206",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 105.2,
    y1: 55.14,
    x2: 106.29,
    y2: 55.14
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-207",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 109.08,
    y1: 52.67,
    x2: 106.79,
    y2: 52.67
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-208",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 86.43,
    y1: 52.67,
    x2: 84.14,
    y2: 52.67
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-209",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 178.99,
    y1: 339.86,
    x2: 178.91,
    y2: 340.01
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-210",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 179.19,
    y1: 339.97,
    x2: 179.11,
    y2: 340.12
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    id: "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,307.58l-2,.09",
    transform: "translate(-206.28 -233.4)"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-2",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,307.87l-2,.09",
    transform: "translate(-206.28 -233.4)"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-3",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,300.07l-2,.09",
    transform: "translate(-206.28 -233.4)"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-4",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.7,468.92l.58.47",
    transform: "translate(-206.28 -233.4)"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-5",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.58,468.92l.08.06",
    transform: "translate(-206.28 -233.4)"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-6",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.73,521c0,.17,0,.34,0,.51",
    transform: "translate(-206.28 -233.4)"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-7",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,302c-.75,0-1.51,0-2.26,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-8",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.24,340.6l.15-.25",
    transform: "translate(-206.28 -233.4)"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-9",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,297.79c-.68,0-1.35.1-2,.17",
    transform: "translate(-206.28 -233.4)"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-10",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,302.5c-.75,0-1.51,0-2.26,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-11",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,298.34c-.68.05-1.35.1-2,.17",
    transform: "translate(-206.28 -233.4)"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-12",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,292.18l-2,.17",
    transform: "translate(-206.28 -233.4)"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-13",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,290.68c-.68.06-1.35.13-2,.22",
    transform: "translate(-206.28 -233.4)"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-14",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,293.42c-.75,0-1.51,0-2.26,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-15",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,291.42c-.68.06-1.35.14-2,.23",
    transform: "translate(-206.28 -233.4)"
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-16",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,294.16c-.75,0-1.51,0-2.26,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-17",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,287.65c-.68.06-1.35.14-2,.23",
    transform: "translate(-206.28 -233.4)"
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-18",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,287.11c-.68.06-1.35.15-2,.25",
    transform: "translate(-206.28 -233.4)"
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-19",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,288.09c-.75,0-1.51,0-2.26,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-20",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,288.93c-.66,0-1.32,0-2,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-21",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.94,406.31c.18.28.35.56.54.84",
    transform: "translate(-206.28 -233.4)"
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-22",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.48,407.15c.13.21.27.41.41.61",
    transform: "translate(-206.28 -233.4)"
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-23",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.94,395.05s0,.08,0,.12",
    transform: "translate(-206.28 -233.4)"
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-24",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.94,395a8.51,8.51,0,0,0,8.46,7.68",
    transform: "translate(-206.28 -233.4)"
  }))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-25",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.35,394.88a7.09,7.09,0,0,0,7.05,6.4",
    transform: "translate(-206.28 -233.4)"
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-26",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.42,361.54v0",
    transform: "translate(-206.28 -233.4)"
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-27",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.76,401.28a1.43,1.43,0,0,0,1.42-1.42",
    transform: "translate(-206.28 -233.4)"
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-28",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M382.83,395q1.77-18,3.19-36.1",
    transform: "translate(-206.28 -233.4)"
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-29",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386.05,358.65q3.34-42.78,4.75-85.7",
    transform: "translate(-206.28 -233.4)"
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-30",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M381.42,394.88q1.79-18.15,3.21-36.34",
    transform: "translate(-206.28 -233.4)"
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-31",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.63,358.54q3.45-43.87,4.82-87.88",
    transform: "translate(-206.28 -233.4)"
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-32",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388,314.19l.11-.26",
    transform: "translate(-206.28 -233.4)"
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-33",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.5,332.34l2,.08",
    transform: "translate(-206.28 -233.4)"
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-34",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.5,332l2,.09",
    transform: "translate(-206.28 -233.4)"
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-35",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.5,339.84q1,.06,2,.09",
    transform: "translate(-206.28 -233.4)"
  }))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-36",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.54,311.3c.11.27.23.54.34.8",
    transform: "translate(-206.28 -233.4)"
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-37",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.63,340.5l.08-.14",
    transform: "translate(-206.28 -233.4)"
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-38",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302,338.06c.75,0,1.51,0,2.26,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-39",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302,337.51c.75,0,1.51,0,2.26,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-40",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.45,276.4c-.45.56-.89,1.13-1.3,1.72",
    transform: "translate(-206.28 -233.4)"
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-41",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.57,280.8c-.35.55-.67,1.12-1,1.7",
    transform: "translate(-206.28 -233.4)"
  }))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-42",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.36,282.36l-.05.11",
    transform: "translate(-206.28 -233.4)"
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-43",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302,288.92l-.18-.11",
    transform: "translate(-206.28 -233.4)"
  }))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-44",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.76,288.2a.58.58,0,0,0-.45.56",
    transform: "translate(-206.28 -233.4)"
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-45",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,312.66H302",
    transform: "translate(-206.28 -233.4)"
  }))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-46",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,304.28h-2.27",
    transform: "translate(-206.28 -233.4)"
  }))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-47",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,307.67l-2-.09",
    transform: "translate(-206.28 -233.4)"
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-48",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,313H302",
    transform: "translate(-206.28 -233.4)"
  }))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-49",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,308l-2-.09",
    transform: "translate(-206.28 -233.4)"
  }))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-50",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,300.16l-2-.09",
    transform: "translate(-206.28 -233.4)"
  }))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-51",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,295.14h-2.27",
    transform: "translate(-206.28 -233.4)"
  }))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-52",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,298c-.67-.07-1.34-.12-2-.17",
    transform: "translate(-206.28 -233.4)"
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-53",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,298.51c-.67-.07-1.34-.12-2-.17",
    transform: "translate(-206.28 -233.4)"
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-54",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,292.35l-2-.17",
    transform: "translate(-206.28 -233.4)"
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-55",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,290.9c-.67-.09-1.34-.16-2-.22",
    transform: "translate(-206.28 -233.4)"
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-56",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,289h-2.27",
    transform: "translate(-206.28 -233.4)"
  }))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-57",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,291.65c-.67-.09-1.34-.17-2-.23",
    transform: "translate(-206.28 -233.4)"
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-58",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,287.88c-.67-.09-1.34-.17-2-.23",
    transform: "translate(-206.28 -233.4)"
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-59",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,287.36c-.67-.1-1.34-.19-2-.25",
    transform: "translate(-206.28 -233.4)"
  }))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-60",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.18,351.93h1.42",
    transform: "translate(-206.28 -233.4)"
  }))), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-61",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,286.59c-.76,0-1.51,0-2.27,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-62",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.18,353.42h1.42",
    transform: "translate(-206.28 -233.4)"
  }))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-63",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.2,286.64a42,42,0,0,0-5.36.68",
    transform: "translate(-206.28 -233.4)"
  }))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-64",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.93,287.32a42,42,0,0,0-5.36-.68",
    transform: "translate(-206.28 -233.4)"
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-65",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.18,351.09h1.42",
    transform: "translate(-206.28 -233.4)"
  }))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-66",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,288.93H304",
    transform: "translate(-206.28 -233.4)"
  }))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-67",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311,288.2l-.14,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-68",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.9,288.18l-.14,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-69",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.82,395.17a.49.49,0,0,1,0-.12",
    transform: "translate(-206.28 -233.4)"
  }))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-70",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.37,402.7a8.49,8.49,0,0,0,8.46-7.68",
    transform: "translate(-206.28 -233.4)"
  }))), _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-71",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.37,401.28a7.08,7.08,0,0,0,7.05-6.4",
    transform: "translate(-206.28 -233.4)"
  }))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-72",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399,521.53a4.38,4.38,0,0,0,0-.51",
    transform: "translate(-206.28 -233.4)"
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-73",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.6,399.86a1.42,1.42,0,0,0,1.41,1.42",
    transform: "translate(-206.28 -233.4)"
  }))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-74",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.75,358.92q1.42,18.06,3.19,36.1",
    transform: "translate(-206.28 -233.4)"
  }))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-75",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215,273q1.4,42.9,4.76,85.7",
    transform: "translate(-206.28 -233.4)"
  }))), _g295 || (_g295 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-76",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.59,282.5q.6,15.74,1.45,31.45",
    transform: "translate(-206.28 -233.4)"
  }))), _g296 || (_g296 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-77",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.14,358.54q1.43,18.19,3.21,36.34",
    transform: "translate(-206.28 -233.4)"
  }))), _g297 || (_g297 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-78",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.32,270.66q1.38,44,4.82,87.88",
    transform: "translate(-206.28 -233.4)"
  }))), _g298 || (_g298 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-79",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.39,404.08l.85,1.07",
    transform: "translate(-206.28 -233.4)"
  }))), _g299 || (_g299 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-80",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302,327.35h2.26",
    transform: "translate(-206.28 -233.4)"
  }))), _g300 || (_g300 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-81",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.75,335.72H304",
    transform: "translate(-206.28 -233.4)"
  }))), _g301 || (_g301 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-82",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.27,332.42l2-.08",
    transform: "translate(-206.28 -233.4)"
  }))), _g302 || (_g302 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-83",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302,327.06h2.26",
    transform: "translate(-206.28 -233.4)"
  }))), _g303 || (_g303 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-84",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.27,332.13l2-.09",
    transform: "translate(-206.28 -233.4)"
  }))), _g304 || (_g304 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-85",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.27,339.93q1,0,2-.09",
    transform: "translate(-206.28 -233.4)"
  }))), _g305 || (_g305 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-86",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.18,344.87h1.42",
    transform: "translate(-206.28 -233.4)"
  }))), _g306 || (_g306 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-87",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.18,346.6h1.42",
    transform: "translate(-206.28 -233.4)"
  }))), _g307 || (_g307 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-88",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.18,351h1.42",
    transform: "translate(-206.28 -233.4)"
  }))), _g308 || (_g308 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-89",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.18,345.86h1.42",
    transform: "translate(-206.28 -233.4)"
  }))), _g309 || (_g309 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-90",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.62,278.12c-.41-.59-.84-1.16-1.3-1.72",
    transform: "translate(-206.28 -233.4)"
  }))), _g310 || (_g310 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-91",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391.53,273.63c-.23-.24-.48-.46-.73-.68",
    transform: "translate(-206.28 -233.4)"
  }))), _g311 || (_g311 = /*#__PURE__*/React.createElement("g", {
    id: "ARC-92",
    "data-name": "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M311.47,288.76a.58.58,0,0,0-.46-.56",
    transform: "translate(-206.28 -233.4)"
  }))), _g312 || (_g312 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,291.12c.27-.39.56-.78.85-1.15s.56-.66.85-1",
    transform: "translate(-206.28 -233.4)"
  }))), _g313 || (_g313 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-2",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,289c.3.32.58.65.85,1s.58.76.85,1.15",
    transform: "translate(-206.28 -233.4)"
  }))), _g314 || (_g314 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-3",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,287.65a7.66,7.66,0,0,1,.76.5,9.59,9.59,0,0,1,.78.65",
    transform: "translate(-206.28 -233.4)"
  }))), _g315 || (_g315 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-4",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295,289.38c.25-.29.51-.56.78-.83a10,10,0,0,1,.77-.67",
    transform: "translate(-206.28 -233.4)"
  }))), _g316 || (_g316 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-5",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,287.88c.27.21.52.44.77.67s.53.54.77.83",
    transform: "translate(-206.28 -233.4)"
  }))), _g317 || (_g317 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-6",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.72,288.8a9.59,9.59,0,0,1,.78-.65,7.8,7.8,0,0,1,.77-.5",
    transform: "translate(-206.28 -233.4)"
  }))), _g318 || (_g318 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-7",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,298.56c.14-.3.28-.6.43-.9.41-.85.83-1.69,1.27-2.52",
    transform: "translate(-206.28 -233.4)"
  }))), _g319 || (_g319 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-8",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,295.14l.42.81c.45.86.87,1.73,1.28,2.61",
    transform: "translate(-206.28 -233.4)"
  }))), _g320 || (_g320 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-9",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,292.18c.12.2.25.39.38.59.4.64.79,1.29,1.16,2",
    transform: "translate(-206.28 -233.4)"
  }))), _g321 || (_g321 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-10",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295,295.14l.39-.74c.37-.69.75-1.37,1.16-2",
    transform: "translate(-206.28 -233.4)"
  }))), _g322 || (_g322 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-11",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,292.35l.38.66c.41.7.79,1.41,1.16,2.13",
    transform: "translate(-206.28 -233.4)"
  }))), _g323 || (_g323 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-12",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.72,294.72l.39-.68c.37-.63.75-1.25,1.16-1.86",
    transform: "translate(-206.28 -233.4)"
  }))), _g324 || (_g324 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-13",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,308.59c.14-.36.29-.73.43-1.1.41-1.07.84-2.14,1.27-3.21",
    transform: "translate(-206.28 -233.4)"
  }))), _g325 || (_g325 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-14",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,304.28l.42,1.05c.44,1.09.86,2.17,1.28,3.26",
    transform: "translate(-206.28 -233.4)"
  }))), _g326 || (_g326 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-15",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,300.07c.12.29.25.58.38.87.39.91.78,1.83,1.16,2.74",
    transform: "translate(-206.28 -233.4)"
  }))), _g327 || (_g327 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-16",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295,303.91l.39-1c.38-.93.76-1.85,1.16-2.78",
    transform: "translate(-206.28 -233.4)"
  }))), _g328 || (_g328 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-17",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,300.16c.13.3.25.61.38.91.4.94.78,1.89,1.16,2.84",
    transform: "translate(-206.28 -233.4)"
  }))), _g329 || (_g329 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-18",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.72,303.68l.39-.93c.38-.9.76-1.79,1.16-2.68",
    transform: "translate(-206.28 -233.4)"
  }))), _g330 || (_g330 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-19",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,286.59a4.17,4.17,0,0,1,.85.19,6.42,6.42,0,0,1,.85.37",
    transform: "translate(-206.28 -233.4)"
  }))), _g331 || (_g331 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-20",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,287.15a6.42,6.42,0,0,1,.85-.37,4.17,4.17,0,0,1,.85-.19",
    transform: "translate(-206.28 -233.4)"
  }))), _g332 || (_g332 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-21",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,331.41c.14.37.29.73.43,1.1.41,1.07.84,2.14,1.27,3.21",
    transform: "translate(-206.28 -233.4)"
  }))), _g333 || (_g333 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-22",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304,335.72l.42-1.05c.44-1.08.86-2.17,1.28-3.26",
    transform: "translate(-206.28 -233.4)"
  }))), _g334 || (_g334 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-23",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295,336.09l.39,1c.38.93.76,1.86,1.16,2.78",
    transform: "translate(-206.28 -233.4)"
  }))), _g335 || (_g335 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-24",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,339.93c.12-.29.25-.58.38-.87.39-.91.78-1.82,1.16-2.74",
    transform: "translate(-206.28 -233.4)"
  }))), _g336 || (_g336 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-25",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,339.84c.13-.3.25-.6.38-.91.4-.94.78-1.89,1.16-2.84",
    transform: "translate(-206.28 -233.4)"
  }))), _g337 || (_g337 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-26",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.72,336.32l.39.94c.38.89.76,1.78,1.16,2.67",
    transform: "translate(-206.28 -233.4)"
  }))), _g338 || (_g338 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-27",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.5,298l-.39-.75c-.37-.7-.76-1.39-1.16-2.07",
    transform: "translate(-206.28 -233.4)"
  }))), _g339 || (_g339 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-28",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,294.72c-.13.24-.26.48-.38.73-.41.77-.79,1.55-1.16,2.34",
    transform: "translate(-206.28 -233.4)"
  }))), _g340 || (_g340 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-29",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.27,297.79l-.39-.81c-.37-.76-.76-1.52-1.16-2.26",
    transform: "translate(-206.28 -233.4)"
  }))), _g341 || (_g341 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-30",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.82,295.14l-.38.66c-.4.71-.79,1.43-1.16,2.16",
    transform: "translate(-206.28 -233.4)"
  }))), _g342 || (_g342 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-31",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,308.59c.17.34.33.67.5,1,.5,1,1,2,1.49,3.06",
    transform: "translate(-206.28 -233.4)"
  }))), _g343 || (_g343 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-32",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,312.66l.36-1c.35-1,.7-2,1.06-3",
    transform: "translate(-206.28 -233.4)"
  }))), _g344 || (_g344 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-33",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.5,307.67l-.39-1c-.38-.93-.77-1.86-1.16-2.79",
    transform: "translate(-206.28 -233.4)"
  }))), _g345 || (_g345 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-34",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,303.68l-.38.95c-.4,1-.78,2-1.16,2.95",
    transform: "translate(-206.28 -233.4)"
  }))), _g346 || (_g346 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-35",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.27,307.58l-.39-1c-.38-1-.77-1.93-1.16-2.9",
    transform: "translate(-206.28 -233.4)"
  }))), _g347 || (_g347 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-36",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.82,303.91c-.13.3-.25.61-.38.91-.39.95-.78,1.9-1.16,2.85",
    transform: "translate(-206.28 -233.4)"
  }))), _g348 || (_g348 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-37",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,338.05l.24.59c.23.58.47,1.15.71,1.71",
    transform: "translate(-206.28 -233.4)"
  }))), _g349 || (_g349 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-211",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 98.97,
    y1: 106.95,
    x2: 99.02,
    y2: 107.07
  }))), _g350 || (_g350 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-212",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 99.02,
    y1: 107.07,
    x2: 99.08,
    y2: 107.2
  }))), _g351 || (_g351 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-213",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 94.29,
    y1: 107.21,
    x2: 94.35,
    y2: 107.1
  }))), _g352 || (_g352 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-38",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.71,340.36l.34-.56,1-1.74",
    transform: "translate(-206.28 -233.4)"
  }))), _g353 || (_g353 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-39",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.17,288.15a3.69,3.69,0,0,0-1.27,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g354 || (_g354 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-40",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M294.84,287.32a4.57,4.57,0,0,1,.83-.07,4.72,4.72,0,0,1,.83.11",
    transform: "translate(-206.28 -233.4)"
  }))), _g355 || (_g355 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-41",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.51,287.11a4.16,4.16,0,0,1,.85-.33,4.6,4.6,0,0,1,.84-.14",
    transform: "translate(-206.28 -233.4)"
  }))), _g356 || (_g356 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-42",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,287.5a4.62,4.62,0,0,0-.63.11,3.88,3.88,0,0,0-.63.21",
    transform: "translate(-206.28 -233.4)"
  }))), _g357 || (_g357 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-43",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307,287.82a3.88,3.88,0,0,0-.63-.21,4.62,4.62,0,0,0-.63-.11",
    transform: "translate(-206.28 -233.4)"
  }))), _g358 || (_g358 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-44",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.57,286.64a4.86,4.86,0,0,1,.85.14,4.66,4.66,0,0,1,.85.33",
    transform: "translate(-206.28 -233.4)"
  }))), _g359 || (_g359 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-45",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M309.28,287.36a4.6,4.6,0,0,1,.83-.11,4.54,4.54,0,0,1,.82.07",
    transform: "translate(-206.28 -233.4)"
  }))), _g360 || (_g360 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-46",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.87,288.18a3.29,3.29,0,0,0-.63-.07,3.44,3.44,0,0,0-.64,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g361 || (_g361 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-47",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,291.12c.17.17.34.34.5.52.52.56,1,1.15,1.49,1.76",
    transform: "translate(-206.28 -233.4)"
  }))), _g362 || (_g362 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-48",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,293.42l.36-.63c.33-.57.68-1.13,1.06-1.67",
    transform: "translate(-206.28 -233.4)"
  }))), _g363 || (_g363 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-49",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.5,290.9c-.25-.29-.51-.57-.78-.83a8.27,8.27,0,0,0-.77-.69",
    transform: "translate(-206.28 -233.4)"
  }))), _g364 || (_g364 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-50",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,327.35l.36,1c.35,1,.7,2,1.06,3",
    transform: "translate(-206.28 -233.4)"
  }))), _g365 || (_g365 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-51",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,288.09l.36-.29a6,6,0,0,1,1.06-.65",
    transform: "translate(-206.28 -233.4)"
  }))), _g366 || (_g366 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-52",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,287.15c.17.06.34.11.5.18a9.39,9.39,0,0,1,1.49.74",
    transform: "translate(-206.28 -233.4)"
  }))), _g367 || (_g367 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-53",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,288.8c-.27.28-.52.57-.77.87s-.53.67-.77,1",
    transform: "translate(-206.28 -233.4)"
  }))), _g368 || (_g368 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-54",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.27,290.68c-.25-.34-.51-.68-.78-1s-.5-.59-.77-.87",
    transform: "translate(-206.28 -233.4)"
  }))), _g369 || (_g369 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-55",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,331.41l.5-1c.5-1,1-2,1.49-3.06",
    transform: "translate(-206.28 -233.4)"
  }))), _g370 || (_g370 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-56",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.5,332.34l-.39,1c-.38.94-.77,1.87-1.16,2.79",
    transform: "translate(-206.28 -233.4)"
  }))), _g371 || (_g371 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-57",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.82,289.38a9.78,9.78,0,0,0-.77.69c-.27.26-.52.54-.77.83",
    transform: "translate(-206.28 -233.4)"
  }))), _g372 || (_g372 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-58",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,336.32c-.13-.32-.26-.63-.38-.95-.4-1-.78-2-1.16-2.95",
    transform: "translate(-206.28 -233.4)"
  }))), _g373 || (_g373 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-59",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.82,336.09c-.13-.3-.25-.6-.38-.91-.39-.94-.78-1.89-1.16-2.84",
    transform: "translate(-206.28 -233.4)"
  }))), _g374 || (_g374 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-60",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.27,332.42l-.39,1c-.38,1-.77,1.94-1.16,2.9",
    transform: "translate(-206.28 -233.4)"
  }))), _g375 || (_g375 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-61",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,288.93l.36-.29a6,6,0,0,1,1.06-.65",
    transform: "translate(-206.28 -233.4)"
  }))), _g376 || (_g376 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-62",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,288l.45.16a8.53,8.53,0,0,1,1.36.66",
    transform: "translate(-206.28 -233.4)"
  }))), _g377 || (_g377 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-63",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,294.16l.36-.63c.33-.57.68-1.13,1.06-1.68",
    transform: "translate(-206.28 -233.4)"
  }))), _g378 || (_g378 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-64",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,291.85l.5.52c.52.57,1,1.16,1.49,1.78",
    transform: "translate(-206.28 -233.4)"
  }))), _g379 || (_g379 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-65",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,302.5l.36-.88c.34-.84.69-1.68,1.06-2.51",
    transform: "translate(-206.28 -233.4)"
  }))), _g380 || (_g380 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-66",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,299.11c.17.27.34.54.5.81.51.84,1,1.7,1.49,2.57",
    transform: "translate(-206.28 -233.4)"
  }))), _g381 || (_g381 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-67",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,313l.36-1c.35-1,.7-2,1.06-3",
    transform: "translate(-206.28 -233.4)"
  }))), _g382 || (_g382 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-68",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,308.89l.5,1c.5,1,1,2,1.49,3.07",
    transform: "translate(-206.28 -233.4)"
  }))), _g383 || (_g383 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-69",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,298.56l.5.81c.51.85,1,1.7,1.49,2.57",
    transform: "translate(-206.28 -233.4)"
  }))), _g384 || (_g384 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-70",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.27,307.87l-.39-1c-.38-1-.77-1.94-1.16-2.9",
    transform: "translate(-206.28 -233.4)"
  }))), _g385 || (_g385 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-71",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.82,304.21c-.13.3-.25.61-.38.91-.39.94-.78,1.89-1.16,2.84",
    transform: "translate(-206.28 -233.4)"
  }))), _g386 || (_g386 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-72",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,304c-.13.31-.26.63-.38.95-.4,1-.78,2-1.16,2.94",
    transform: "translate(-206.28 -233.4)"
  }))), _g387 || (_g387 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-73",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.5,308l-.39-1c-.38-.94-.77-1.86-1.16-2.79",
    transform: "translate(-206.28 -233.4)"
  }))), _g388 || (_g388 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-74",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.27,298.34l-.39-.81c-.37-.76-.76-1.51-1.16-2.26",
    transform: "translate(-206.28 -233.4)"
  }))), _g389 || (_g389 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-75",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.82,295.71c-.13.21-.25.43-.38.65-.4.71-.79,1.43-1.16,2.15",
    transform: "translate(-206.28 -233.4)"
  }))), _g390 || (_g390 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-76",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,295.27l-.38.73c-.41.77-.79,1.55-1.16,2.34",
    transform: "translate(-206.28 -233.4)"
  }))), _g391 || (_g391 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-77",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,302l.36-.88c.34-.84.69-1.68,1.06-2.51",
    transform: "translate(-206.28 -233.4)"
  }))), _g392 || (_g392 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-78",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.5,298.51l-.39-.75c-.37-.69-.76-1.38-1.16-2.05",
    transform: "translate(-206.28 -233.4)"
  }))), _g393 || (_g393 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-79",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.27,291.42c-.25-.34-.51-.68-.78-1s-.5-.59-.77-.87",
    transform: "translate(-206.28 -233.4)"
  }))), _g394 || (_g394 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-80",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.82,290.14c-.26.21-.52.44-.77.68s-.52.54-.77.83",
    transform: "translate(-206.28 -233.4)"
  }))), _g395 || (_g395 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-81",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,289.55c-.27.28-.52.57-.77.87s-.53.66-.77,1",
    transform: "translate(-206.28 -233.4)"
  }))), _g396 || (_g396 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-82",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.5,291.65c-.25-.29-.51-.57-.78-.83a9.85,9.85,0,0,0-.77-.68",
    transform: "translate(-206.28 -233.4)"
  }))), _g397 || (_g397 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-83",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.39,340.35l.41-.68c.42-.71.84-1.43,1.24-2.16",
    transform: "translate(-206.28 -233.4)"
  }))), _g398 || (_g398 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-84",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,337.5l.32.8c.32.77.64,1.53,1,2.29",
    transform: "translate(-206.28 -233.4)"
  }))), _g399 || (_g399 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-85",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,331.12c.17-.33.33-.67.5-1,.5-1,1-2,1.49-3.06",
    transform: "translate(-206.28 -233.4)"
  }))), _g400 || (_g400 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-86",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M304.3,327.05l.36,1c.35,1,.7,2,1.06,3",
    transform: "translate(-206.28 -233.4)"
  }))), _g401 || (_g401 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-87",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.05,336l-.38-.95c-.4-1-.78-2-1.16-2.95",
    transform: "translate(-206.28 -233.4)"
  }))), _g402 || (_g402 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-88",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M296.5,332l-.39,1c-.38.93-.77,1.86-1.16,2.78",
    transform: "translate(-206.28 -233.4)"
  }))), _g403 || (_g403 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-89",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M307.27,332.13l-.39,1c-.38,1-.77,1.93-1.16,2.9",
    transform: "translate(-206.28 -233.4)"
  }))), _g404 || (_g404 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-90",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.82,335.79c-.13-.3-.25-.6-.38-.91-.39-.94-.78-1.89-1.16-2.84",
    transform: "translate(-206.28 -233.4)"
  }))), _g405 || (_g405 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-91",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.62,362.79a18.32,18.32,0,0,1,.06-3,19.71,19.71,0,0,1,.53-2.94",
    transform: "translate(-206.28 -233.4)"
  }))), _g406 || (_g406 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-92",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.38,468.92l-.21,0a1.92,1.92,0,0,1-.68-.28",
    transform: "translate(-206.28 -233.4)"
  }))), _g407 || (_g407 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-93",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213,460.66a6.8,6.8,0,0,1-.22-.89,9.5,9.5,0,0,1-.15-1.07c-.05-.41-.08-.82-.1-1.22s0-.87,0-1.3",
    transform: "translate(-206.28 -233.4)"
  }))), _g408 || (_g408 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-94",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.21,356.89c0-.11.07-.22.11-.32l.1-.3.09-.26.08-.23s0-.11.08-.17a.31.31,0,0,1,.06-.13.22.22,0,0,1,.05-.08l0,0h0",
    transform: "translate(-206.28 -233.4)"
  }))), _g409 || (_g409 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-214",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.33,
    y1: 175.37,
    x2: 7.34,
    y2: 175.38
  }))), _g410 || (_g410 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-95",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.47,456.18c0-2.62-.05-5.24-.06-7.86s0-5.22,0-7.84,0-5.21,0-7.82,0-5.2,0-7.8",
    transform: "translate(-206.28 -233.4)"
  }))), _g411 || (_g411 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-96",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.41,464.69a9,9,0,0,0,.71,1,9.65,9.65,0,0,0,.92,1,12.87,12.87,0,0,0,1.13,1c.42.33.87.64,1.32.93",
    transform: "translate(-206.28 -233.4)"
  }))), _g412 || (_g412 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-97",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.21,412.83c-.31.11-.63.23-.94.37a5.87,5.87,0,0,0-.75.38,3.44,3.44,0,0,0-.55.39,1.44,1.44,0,0,0-.35.39",
    transform: "translate(-206.28 -233.4)"
  }))), _g413 || (_g413 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-215",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.8,
    y1: 180.11,
    x2: 9.08,
    y2: 181.24
  }))), _g414 || (_g414 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-98",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.38,461.46a2.5,2.5,0,0,1-.21-.35,2.88,2.88,0,0,1-.19-.45",
    transform: "translate(-206.28 -233.4)"
  }))), _g415 || (_g415 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-99",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.19,466.73l-.38-.19c-.38-.19-.75-.38-1.12-.59",
    transform: "translate(-206.28 -233.4)"
  }))), _g416 || (_g416 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-100",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.69,466c-.58-.32-1.15-.67-1.7-1a15.92,15.92,0,0,1-1.46-1.1,11.41,11.41,0,0,1-2.15-2.35",
    transform: "translate(-206.28 -233.4)"
  }))), _g417 || (_g417 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-101",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.27,465.38a3.19,3.19,0,0,1,0,.69,3,3,0,0,1-.1.66",
    transform: "translate(-206.28 -233.4)"
  }))), _g418 || (_g418 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-102",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.19,466.73a3.23,3.23,0,0,1,.16.92,2.56,2.56,0,0,1,0,.39,1.19,1.19,0,0,1-.1.32,1.28,1.28,0,0,1-.15.25.79.79,0,0,1-.2.17,1,1,0,0,1-.23.11,1.15,1.15,0,0,1-.26,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g419 || (_g419 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-103",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.24,405.15a1.66,1.66,0,0,1,.22.3l.09.16a.77.77,0,0,1,.07.16.57.57,0,0,1,0,.14.49.49,0,0,1,0,.12.11.11,0,0,1,0,.08l0,.05",
    transform: "translate(-206.28 -233.4)"
  }))), _g420 || (_g420 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-104",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.27,465.38q-.79-6.36-1.47-12.75-.33-3.18-.64-6.36t-.59-6.35q-.57-6.35-1.1-12.67t-1.11-12.6",
    transform: "translate(-206.28 -233.4)"
  }))), _g421 || (_g421 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-105",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.39,404.08a11.74,11.74,0,0,0-1.09.49l-.43.24c-.12.08-.24.16-.35.25a3.45,3.45,0,0,0-.28.26,1.5,1.5,0,0,0-.19.25.85.85,0,0,0-.11.26.57.57,0,0,0,0,.26",
    transform: "translate(-206.28 -233.4)"
  }))), _g422 || (_g422 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-106",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.21,356.89l0,.2.06.65",
    transform: "translate(-206.28 -233.4)"
  }))), _g423 || (_g423 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-107",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.4,416.33a1.77,1.77,0,0,1,.39-.43l.28-.22.35-.21c.28-.16.57-.29.86-.42s.71-.28,1.08-.4",
    transform: "translate(-206.28 -233.4)"
  }))), _g424 || (_g424 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-108",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.45,408.57a1.08,1.08,0,0,1-.16-.3.82.82,0,0,1,0-.31.85.85,0,0,1,.09-.31,1.25,1.25,0,0,1,.21-.3,3.26,3.26,0,0,1,.33-.31c.14-.11.3-.2.45-.3l.57-.29.68-.29",
    transform: "translate(-206.28 -233.4)"
  }))), _g425 || (_g425 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-109",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.26,412.82h.05a.08.08,0,0,1,0,.05s0,.05,0,.07l0,.11",
    transform: "translate(-206.28 -233.4)"
  }))), _g426 || (_g426 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-110",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.3,413.06a1,1,0,0,1-.09.21c0,.08-.09.16-.14.24",
    transform: "translate(-206.28 -233.4)"
  }))), _g427 || (_g427 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-111",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.39,404.08q-.54-5.85-1.1-11.71-.28-2.91-.55-5.83t-.54-5.8c-.18-1.93-.35-3.85-.52-5.78s-.34-3.84-.5-5.76q-.47-5.73-.88-11.46",
    transform: "translate(-206.28 -233.4)"
  }))), _g428 || (_g428 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-112",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M303.6,340.86a.05.05,0,0,1,0,0l.07,0a1.38,1.38,0,0,1,.27-.08l.45-.05.55,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g429 || (_g429 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-113",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.36,236.61a3.21,3.21,0,0,1,.3-1.29,5,5,0,0,1,.72-1.19",
    transform: "translate(-206.28 -233.4)"
  }))), _g430 || (_g430 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-114",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.36,333.59a10.67,10.67,0,0,1-.11,1.49,8.56,8.56,0,0,1-.31,1.33,7.29,7.29,0,0,1-.48,1.11,6.44,6.44,0,0,1-.62.92,5.59,5.59,0,0,1-.73.73,5.81,5.81,0,0,1-.82.54,5.45,5.45,0,0,1-.87.35,4.53,4.53,0,0,1-.89.18",
    transform: "translate(-206.28 -233.4)"
  }))), _g431 || (_g431 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-115",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.45,270.66a35.63,35.63,0,0,0-4-4.16,40.08,40.08,0,0,0-4.67-3.54",
    transform: "translate(-206.28 -233.4)"
  }))), _g432 || (_g432 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-116",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.38,234.13a2.62,2.62,0,0,1,1.06-.36,3.25,3.25,0,0,1,1.16.1",
    transform: "translate(-206.28 -233.4)"
  }))), _g433 || (_g433 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-117",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.53,340.24c-.94.09-1.88.17-2.82.23s-1.83.11-2.75.14",
    transform: "translate(-206.28 -233.4)"
  }))), _g434 || (_g434 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-118",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.6,233.87c2.76.77,5.47,1.68,8.16,2.66,1.34.49,2.67,1,4,1.52s2.65,1,4,1.58,2.64,1.08,4,1.63l3.93,1.69c2.63,1.15,5.24,2.32,7.84,3.53l3.9,1.84c1.29.62,2.59,1.25,3.88,1.89l3.87,1.95c1.28.66,2.56,1.33,3.83,2q3.8,2.06,7.53,4.26t7.32,4.53",
    transform: "translate(-206.28 -233.4)"
  }))), _g435 || (_g435 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-119",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.24,340.24c.94.09,1.88.17,2.82.23s1.84.11,2.76.14",
    transform: "translate(-206.28 -233.4)"
  }))), _g436 || (_g436 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-120",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.32,270.66a34.91,34.91,0,0,1,4-4.16A39.15,39.15,0,0,1,225,263",
    transform: "translate(-206.28 -233.4)"
  }))), _g437 || (_g437 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-121",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.39,234.13a2.63,2.63,0,0,0-1.05-.36,3.3,3.3,0,0,0-1.17.1",
    transform: "translate(-206.28 -233.4)"
  }))), _g438 || (_g438 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-122",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M287.17,233.87c-2.75.77-5.47,1.68-8.15,2.66-1.34.49-2.68,1-4,1.52s-2.65,1-4,1.58-2.64,1.08-4,1.63L263.15,243c-2.62,1.15-5.24,2.32-7.83,3.53-1.31.61-2.61,1.22-3.9,1.84s-2.6,1.25-3.89,1.89-2.58,1.29-3.86,1.95-2.56,1.33-3.83,2q-3.81,2.06-7.53,4.26T225,263",
    transform: "translate(-206.28 -233.4)"
  }))), _g439 || (_g439 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-123",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.41,236.61a3.21,3.21,0,0,0-.3-1.29,5,5,0,0,0-.72-1.19",
    transform: "translate(-206.28 -233.4)"
  }))), _g440 || (_g440 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-124",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.18,340.86s0,0,0,0l-.07,0a1.2,1.2,0,0,0-.27-.08l-.44-.05-.55,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g441 || (_g441 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-125",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.41,333.59a10.67,10.67,0,0,0,.11,1.49,8.56,8.56,0,0,0,.31,1.33,7.29,7.29,0,0,0,.48,1.11,6.44,6.44,0,0,0,.62.92,6.29,6.29,0,0,0,.73.73,6.45,6.45,0,0,0,.82.54,5.45,5.45,0,0,0,.87.35,4.53,4.53,0,0,0,.89.18",
    transform: "translate(-206.28 -233.4)"
  }))), _g442 || (_g442 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-126",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M295.06,340.44c1.21.12,2.42.22,3.64.29s2.32.11,3.48.12",
    transform: "translate(-206.28 -233.4)"
  }))), _g443 || (_g443 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-216",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.11,
    y1: 0.73,
    x2: 110.11,
    y2: 52.96
  }))), _g444 || (_g444 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-217",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.11,
    y1: 52.96,
    x2: 110.11,
    y2: 55.23
  }))), _g445 || (_g445 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-218",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.11,
    y1: 55.78,
    x2: 110.09,
    y2: 69.59
  }))), _g446 || (_g446 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-219",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.09,
    y1: 69.59,
    x2: 110.09,
    y2: 73.84
  }))), _g447 || (_g447 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-220",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.09,
    y1: 73.84,
    x2: 110.08,
    y2: 80.22
  }))), _g448 || (_g448 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-221",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.08,
    y1: 82.35,
    x2: 110.08,
    y2: 85.46
  }))), _g449 || (_g449 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-222",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.08,
    y1: 85.46,
    x2: 110.08,
    y2: 87.73
  }))), _g450 || (_g450 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-223",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.08,
    y1: 88.28,
    x2: 110.08,
    y2: 90.85
  }))), _g451 || (_g451 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-224",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 110.08,
    y1: 92.98,
    x2: 110.08,
    y2: 99.35
  }))), _g452 || (_g452 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-127",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.35,333.3a10.41,10.41,0,0,1-.12,1.58,7.71,7.71,0,0,1-.37,1.41,6.74,6.74,0,0,1-1.29,2.19,5.25,5.25,0,0,1-.85.78,5.55,5.55,0,0,1-1,.59,6.24,6.24,0,0,1-1,.4,6.14,6.14,0,0,1-1,.19",
    transform: "translate(-206.28 -233.4)"
  }))), _g453 || (_g453 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-225",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.11,
    y1: 0.73,
    x2: 83.11,
    y2: 52.91
  }))), _g454 || (_g454 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-226",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.11,
    y1: 52.91,
    x2: 83.11,
    y2: 55.23
  }))), _g455 || (_g455 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-227",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.11,
    y1: 55.78,
    x2: 83.13,
    y2: 72.89
  }))), _g456 || (_g456 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-228",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.13,
    y1: 72.99,
    x2: 83.14,
    y2: 81.5
  }))), _g457 || (_g457 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-229",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.14,
    y1: 82.88,
    x2: 83.14,
    y2: 90.85
  }))), _g458 || (_g458 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-230",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 83.14,
    y1: 91.7,
    x2: 83.14,
    y2: 99.9
  }))), _g459 || (_g459 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-128",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.42,333.3a9.27,9.27,0,0,0,.13,1.58,7.68,7.68,0,0,0,.36,1.41,6.92,6.92,0,0,0,1.29,2.19,5.7,5.7,0,0,0,.85.78,5.55,5.55,0,0,0,.95.59,6.35,6.35,0,0,0,1,.4,6,6,0,0,0,1,.19",
    transform: "translate(-206.28 -233.4)"
  }))), _g460 || (_g460 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-129",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.72,340.44c-1.22.12-2.43.22-3.65.29s-2.32.11-3.47.12",
    transform: "translate(-206.28 -233.4)"
  }))), _g461 || (_g461 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-130",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.89,284.13c.72,0,1.44,0,2.17.06s1.28.07,1.91.13,1.18.12,1.76.2,1.13.16,1.68.26,1.13.21,1.69.33,1.12.25,1.68.4l1.59.45",
    transform: "translate(-206.28 -233.4)"
  }))), _g462 || (_g462 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-131",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.4,285.92a44.47,44.47,0,0,1,12.49-1.79",
    transform: "translate(-206.28 -233.4)"
  }))), _g463 || (_g463 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-132",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.22,280.82c.11.18.22.36.32.54.32.54.62,1.09.9,1.66",
    transform: "translate(-206.28 -233.4)"
  }))), _g464 || (_g464 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-133",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.89,239.44a45.92,45.92,0,0,1,6.3.46,59.2,59.2,0,0,1,6.18,1.22",
    transform: "translate(-206.28 -233.4)"
  }))), _g465 || (_g465 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-134",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.89,239.44a45.7,45.7,0,0,0-6.3.46,58.19,58.19,0,0,0-6.18,1.22",
    transform: "translate(-206.28 -233.4)"
  }))), _g466 || (_g466 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-135",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M399,521.55c-.2,4.52-.57,9-1.18,13.5a124.39,124.39,0,0,1-2.54,13.28,106.07,106.07,0,0,1-4.08,12.86,94.14,94.14,0,0,1-5.75,12.19",
    transform: "translate(-206.28 -233.4)"
  }))), _g467 || (_g467 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-136",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M385.39,573.52A85.5,85.5,0,0,1,375,588",
    transform: "translate(-206.28 -233.4)"
  }))), _g468 || (_g468 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-137",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.75,521.56c.2,4.51.58,9,1.19,13.5a119.87,119.87,0,0,0,2.54,13.27,106.67,106.67,0,0,0,4.07,12.86,94.14,94.14,0,0,0,5.75,12.19",
    transform: "translate(-206.28 -233.4)"
  }))), _g469 || (_g469 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-138",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.38,573.52a86.6,86.6,0,0,0,7.51,11.08c.93,1.17,1.88,2.31,2.87,3.42",
    transform: "translate(-206.28 -233.4)"
  }))), _g470 || (_g470 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-139",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.78,294.18a48,48,0,0,1,.89-10.57,38.53,38.53,0,0,1,1.39-5.16,28.34,28.34,0,0,1,2.18-4.83",
    transform: "translate(-206.28 -233.4)"
  }))), _g471 || (_g471 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-140",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M396,294.18a48,48,0,0,0-.88-10.57,38,38,0,0,0-1.4-5.15,27.25,27.25,0,0,0-2.18-4.83",
    transform: "translate(-206.28 -233.4)"
  }))), _g472 || (_g472 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-141",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.89,236.86a45.7,45.7,0,0,0-6.3.46,58.19,58.19,0,0,0-6.18,1.22",
    transform: "translate(-206.28 -233.4)"
  }))), _g473 || (_g473 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-142",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M315.37,238.54a59.2,59.2,0,0,0-6.18-1.22,45.92,45.92,0,0,0-6.3-.46",
    transform: "translate(-206.28 -233.4)"
  }))), _g474 || (_g474 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-143",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.53,465.35q-1.26-9.68-2.24-19.38c-.65-6.43-1.23-12.88-1.82-19.32",
    transform: "translate(-206.28 -233.4)"
  }))), _g475 || (_g475 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-144",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.16,409.61a3.1,3.1,0,0,1,.27-.93,3.76,3.76,0,0,1,.63-.92",
    transform: "translate(-206.28 -233.4)"
  }))), _g476 || (_g476 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-231",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.13,
    y1: 128.1,
    x2: 6.82,
    y2: 124.08
  }))), _g477 || (_g477 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-145",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.09,357.49c0-.29-.05-.58-.08-.87-.07-.61-.17-1.21-.3-1.81",
    transform: "translate(-206.28 -233.4)"
  }))), _g478 || (_g478 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-232",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.43,
    y1: 121.41,
    x2: 6.4,
    y2: 121.24
  }))), _g479 || (_g479 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-146",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215,273l-.18.17c-.19.16-.37.33-.55.5",
    transform: "translate(-206.28 -233.4)"
  }))), _g480 || (_g480 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-147",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.76,588a85.83,85.83,0,0,0,6.19,6.32q3.28,3,6.88,5.73t7.64,5.15q4.11,2.47,8.44,4.55a100.28,100.28,0,0,0,20.16,7.13,97.93,97.93,0,0,0,11.39,2,99.15,99.15,0,0,0,11.43.65",
    transform: "translate(-206.28 -233.4)"
  }))), _g481 || (_g481 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-148",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375,588a84.16,84.16,0,0,1-7.11,7.15,90,90,0,0,1-7.89,6.3,93.93,93.93,0,0,1-8.55,5.41,99.29,99.29,0,0,1-9.08,4.48q-4.67,2-9.5,3.55a94.45,94.45,0,0,1-9.82,2.57,99.75,99.75,0,0,1-20.17,2",
    transform: "translate(-206.28 -233.4)"
  }))), _g482 || (_g482 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-149",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.53,465.35a5.66,5.66,0,0,1,0,1.79,4.4,4.4,0,0,1-.51,1.45,3,3,0,0,1-.37.51,2.1,2.1,0,0,1-.42.37,1.57,1.57,0,0,1-.45.22,1.44,1.44,0,0,1-.46.08",
    transform: "translate(-206.28 -233.4)"
  }))), _g483 || (_g483 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-233",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.18,
    y1: 193.05,
    x2: 13.2,
    y2: 193.25
  }))), _g484 || (_g484 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-234",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.18,
    y1: 193.05,
    x2: 11.96,
    y2: 179.95
  }))), _g485 || (_g485 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-150",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.24,413.35a5.43,5.43,0,0,0-.09-.56,2.28,2.28,0,0,0-.15-.44.7.7,0,0,0-.09-.17.47.47,0,0,0-.09-.12.28.28,0,0,0-.19-.09",
    transform: "translate(-206.28 -233.4)"
  }))), _g486 || (_g486 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-151",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.06,407.76l.2-.19a4.55,4.55,0,0,1,.81-.57",
    transform: "translate(-206.28 -233.4)"
  }))), _g487 || (_g487 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-152",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.07,407a.24.24,0,0,0,.09-.08,1.19,1.19,0,0,0,.09-.15,2,2,0,0,0,.14-.47,4.48,4.48,0,0,0,.07-.64,4,4,0,0,0,0-.69",
    transform: "translate(-206.28 -233.4)"
  }))), _g488 || (_g488 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-153",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.44,405c-.7-7.28-1.42-14.55-2.12-21.83s-1.35-14.38-1.91-21.58",
    transform: "translate(-206.28 -233.4)"
  }))), _g489 || (_g489 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-154",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.61,362.17q.63-9.74,1.26-19.46T395,323.38",
    transform: "translate(-206.28 -233.4)"
  }))), _g490 || (_g490 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-235",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.55,
    y1: 80.79,
    x2: 11.43,
    y2: 80.53
  }))), _g491 || (_g491 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-155",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.32,403.19q8.38,0,16.76-.05h53.81",
    transform: "translate(-206.28 -233.4)"
  }))), _g492 || (_g492 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-156",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.38,240.87c1-.26,2-.49,3.07-.7a48.33,48.33,0,0,1,9.44-1",
    transform: "translate(-206.28 -233.4)"
  }))), _g493 || (_g493 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-157",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M392.68,364c0-.16,0-.32,0-.48a9.26,9.26,0,0,0-.08-1.39",
    transform: "translate(-206.28 -233.4)"
  }))), _g494 || (_g494 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-158",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.63,354.52s0,0,0,0a.13.13,0,0,0,0,.06.34.34,0,0,1,0,.09v.12",
    transform: "translate(-206.28 -233.4)"
  }))), _g495 || (_g495 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-236",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 6.33,
    y1: 121.41,
    x2: 6.34,
    y2: 121.96
  }))), _g496 || (_g496 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-159",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387,358.62q.44-5.6.83-11.17c.26-3.7.52-7.41.76-11.11s.46-7.37.68-11,.42-7.33.61-11",
    transform: "translate(-206.28 -233.4)"
  }))), _g497 || (_g497 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-160",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M389.9,314.3q.54-10.24,1-20.49.4-10.08.67-20.18",
    transform: "translate(-206.28 -233.4)"
  }))), _g498 || (_g498 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-237",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 167.17,
    y1: 169.78,
    x2: 168.39,
    y2: 169.79
  }))), _g499 || (_g499 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-161",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M374.66,403.19a9.32,9.32,0,0,0,3.22-.55,8.11,8.11,0,0,0,1.43-.67,8.21,8.21,0,0,0,1.29-.89,9,9,0,0,0,2.09-2.47,9.12,9.12,0,0,0,1.13-3.44",
    transform: "translate(-206.28 -233.4)"
  }))), _g500 || (_g500 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-162",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.83,395.05c.3-3,.58-6.07.87-9.11q1.24-13.51,2.3-27.06",
    transform: "translate(-206.28 -233.4)"
  }))), _g501 || (_g501 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-163",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.89,403.14h53.8l8.53,0h4.16l4.07,0",
    transform: "translate(-206.28 -233.4)"
  }))), _g502 || (_g502 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-164",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.89,239.18a45.92,45.92,0,0,1,6.3.46,59.2,59.2,0,0,1,6.18,1.22",
    transform: "translate(-206.28 -233.4)"
  }))), _g503 || (_g503 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-165",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.11,408.79c0,.11,0,.23,0,.35s0,.09,0,.14v.12s0,.07,0,.1v.07s0,0,0,.05h0",
    transform: "translate(-206.28 -233.4)"
  }))), _g504 || (_g504 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-166",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.24,273.62c.09,3.35.2,6.7.31,10.05q.25,7.62.58,15.24t.74,15.39",
    transform: "translate(-206.28 -233.4)"
  }))), _g505 || (_g505 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-167",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.87,314.3c.18,3.39.37,6.79.57,10.18s.4,6.82.62,10.24q.65,10.3,1.44,20.62",
    transform: "translate(-206.28 -233.4)"
  }))), _g506 || (_g506 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-168",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.29,469.77a1.29,1.29,0,0,1-.51-.1,1.65,1.65,0,0,1-.5-.28",
    transform: "translate(-206.28 -233.4)"
  }))), _g507 || (_g507 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-169",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.67,354.64l-.51-7.85c-.49-7.81-1-15.61-1.35-23.42",
    transform: "translate(-206.28 -233.4)"
  }))), _g508 || (_g508 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-170",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M218.77,358.88c.21,2.72.43,5.43.65,8.15q1,12.35,2.2,24.69",
    transform: "translate(-206.28 -233.4)"
  }))), _g509 || (_g509 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-238",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.35,
    y1: 158.32,
    x2: 15.67,
    y2: 161.64
  }))), _g510 || (_g510 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-171",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222,395.17a8.9,8.9,0,0,0,3.21,5.91,9.21,9.21,0,0,0,2.72,1.56,9.32,9.32,0,0,0,3.22.55",
    transform: "translate(-206.28 -233.4)"
  }))), _g511 || (_g511 = /*#__PURE__*/React.createElement("g", {
    id: "LINE-239",
    "data-name": "LINE"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.83,
    y1: 169.79,
    x2: 26.05,
    y2: 169.78
  }))), _g512 || (_g512 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-172",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.55,412l-.37.2a5.19,5.19,0,0,0-.85.63",
    transform: "translate(-206.28 -233.4)"
  }))), _g513 || (_g513 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-173",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.47,282.47l-.29-.55c-.3-.54-.62-1.07-.95-1.59",
    transform: "translate(-206.28 -233.4)"
  }))), _g514 || (_g514 = /*#__PURE__*/React.createElement("g", {
    id: "SPLINE-174",
    "data-name": "SPLINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M216.55,280.33l-.32.5q-.45.75-.87,1.53",
    transform: "translate(-206.28 -233.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarmosharkM9);
export default __webpack_public_path__ + "static/media/darmoshark-m9.8370784b96a74ff95360d50add74274f.svg";
export { ForwardRef as ReactComponent };